/**
 * Log severity levels matching backend Serilog levels
 */
export enum LogLevel {
  Debug = 1,
  Information = 2,
  Warning = 3,
  Error = 4,
}
